import type { FC } from 'react'
import { ToggleButtonGroup as MuiToggleButtonGroup, type ToggleButtonGroupProps as MuiToggleButtonGroupProps } from '@mui/material'

/**
 * The MUI ToggleButtonGroup with `color` and `size` taken out.
 *
 * The theme already sets these, so passing them does nothing.
 * Hiding them from the type just stops us doing it by accident.
 */
type ToggleButtonGroupProps = Omit<MuiToggleButtonGroupProps, 'color' | 'size'>

export const ToggleButtonGroup: FC<ToggleButtonGroupProps> = MuiToggleButtonGroup
